import yup from "src/validators/yup.Module";

export interface TributacaoCfopImpostoCadastroDto {
  id: number;
  tributacaoCFOPId: number;
  tipoImposto: number;
  tipoImpostoDescricao: string;
  cst: number;
  aliquotaSimples: string;
}

export const TributacaoCfopImpostoCadastroSchema = yup.object().shape({
  nome: yup
    .string()
    .notRequired()
    .min(3, "O nome deve ter no mínimo 3 caracteres"),
});
